import React from 'react';
import type {ItemAssignmentSimpleResponse} from 'src/api/ProactApiClient';
import {PageHeader} from 'src/design/organisms/PageHeader';
import {DataList} from 'src/design/organisms/DataList';
import {useListState} from 'src/design/organisms/useListState';
import {useGetItemAssignmentListQuery} from 'src/redux/queries/itemAssignment';
import useDebounce from 'src/shared/hooks/useDebounce';
import {
  HandleItemAssignmentRowDetailRender,
  HandleItemAssignmentRowSubTextRender,
  ItemAssignmentPillConfig,
} from './itemAssignmentHelpers';

const maxPageRows = 10;
export interface ItemAssignmentsPendingReviewListProps {
  titleText?: string;

  onNavigateTo: (itemDefinitionId: string, id: string) => void;
}

export const ItemAssignmentsPendingReviewList: React.FC<
  ItemAssignmentsPendingReviewListProps
> = ({titleText, onNavigateTo}) => {
  const {
    searchTerm,
    setSearchTerm,
    currentPage,
    handlePageChange,
    start,
    length,
  } = useListState({
    identifier: 'item-assignments-pending-review',
    pageSize: maxPageRows,
  });
  const debouncedSearchTerm = useDebounce(searchTerm, 300);

  const {data, isLoading} = useGetItemAssignmentListQuery({
    start,
    length,
    isPendingCurrentUserApproval: true,
    search: debouncedSearchTerm,
  });

  const indexListData: ItemAssignmentSimpleResponse[] = data?.data ?? [];
  const totalRecords = data?.totalRecords ?? 0;

  const handleNavigateToAssignment = (id: any, row: any) =>
    onNavigateTo(row.itemDefinitionId, id);

  return (
    <>
      <PageHeader>
        <PageHeader.Title>
          {titleText ?? 'Pending Approval Assignments'}
        </PageHeader.Title>
        <PageHeader.Search
          value={searchTerm}
          onChange={setSearchTerm}
          placeholder="Search..."
        />
      </PageHeader>
      <DataList
        isLoading={isLoading}
        data={indexListData}
        meta={undefined}
        currentPage={currentPage}
        recordsPerPage={length}
        totalRecords={totalRecords}
        onRowTextRender={(item: ItemAssignmentSimpleResponse) =>
          `${item.itemDefinition?.name ?? 'Unknown Item'} (${
            item.assignedToUser?.name ?? 'Unknown User'
          })`
        }
        onRowClick={handleNavigateToAssignment}
        onPageChange={handlePageChange}
        onGetPillMapping={(item: ItemAssignmentSimpleResponse) =>
          ItemAssignmentPillConfig(item)
        }
        onRowSubTextRender={HandleItemAssignmentRowSubTextRender}
        onRenderDetailRowNode={HandleItemAssignmentRowDetailRender}
        hasCreationLogic={false}
      />
    </>
  );
};
